// extracted by mini-css-extract-plugin
module.exports = {"cont":"ChatV1Mobile_cont__Bm_dC"};